<template>
  <svg width="15" height="6" viewBox="0 0 15 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.26042 5.87402V4.05908L0 4.05908V1.88257L6.26042 1.88257V0.125977L15 2.88257L6.26042 5.87402Z" fill="#CE123D"/>
  </svg>
</template>
